import { Component, ChangeDetectionStrategy, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { SharedService } from 'src/app/shared/shared.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SubRehababilitationModel } from 'src/app/case-application/substanial-rehabilitation/models/sub-rehab.model';


@Component({
  selector: 'app-back-next-navigator',
  templateUrl: './back-next-navigator.component.html',
  styleUrls: ['./back-next-navigator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BackNextNavigatorComponent implements OnInit, OnDestroy {
  @Input() hideBack = false;
  @Input() hideNext;
  @Input() showSubmit;
  nextLabel = 'Next';
  @Output() nextScreenEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() previousScreenEmitter: EventEmitter<any> = new EventEmitter<any>();
  form: FormGroup;
  constructor(
    private sharedService: SharedService,
    private fb: FormBuilder
  ) {
    this.form = SubRehababilitationModel.asForm(this.fb);
  }

  ngOnInit() {
    this.sharedService.header.next('Cases');
    if(this.showSubmit){
      this.nextLabel = "Submit";
    }
  }

  ngOnDestroy() {

  }
}
